import { useTranslation } from "react-i18next";

import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { SWMLeftMenuList } from "../utils/constants";

const Solid_wastes_home = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {SWMLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Solid Wastes/Refuses - where to dispose them?")}
                    </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <p className="fontSizeClass">
                      <strong>
                        {t("Take a look at the steps to be taken by you")}
                      </strong>
                      <br />
                      {t(
                        "Cleaning your own garden?Renovating your house ? Erecting a scaffolding,or making any other temporary structure on the footpath ? Thinking about where to dispose off broken stems,leaves,roots,bricks,bits & pieces of concrete or cement slabs and the leftovers of scaffolding like bamboos,mats and ropes?"
                      )}
                    </p>
                    <h5 className="fontSizeClass">
                      {t(
                        "As a responsible citizen,you should be aware of some of the following simple facts:"
                      )}
                    </h5>
                    <div className="row">
                      <div className="col-lg-6">
                        <div id="accordion">
                          <div className="card">
                            <div className="card-header" id="heading1">
                              <button
                                class="btn btn-link fontSizeClass "
                                data-toggle="collapse"
                                data-target="#collapse1"
                                aria-expanded="true"
                                aria-controls="collapse1"
                              >
                                {"Do's"}
                              </button>
                            </div>
                            <div
                              id="collapse1"
                              className="collapse show"
                              data-parent="#accordion"
                            >
                              <div className="card-body m-3">
                                <ol className="kmc-function-list" type="1">
                                  {[
                                    "To contact your local Solid Waste Management Dept.(SWM)Ward Office.",
                                    "To deposit the required fee.",
                                    "To obtain a receipt/permission from the KMC office.",
                                    "To intimate the KMC office on the commencement of the work.",
                                  ].map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ol>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div id="accordion">
                          <div className="card">
                            <div className="card-header" id="heading2">
                              <button
                                class="btn btn-link fontSizeClass "
                                data-toggle="collapse"
                                data-target="#collapse2"
                                aria-expanded="true"
                                aria-controls="collapse2"
                              >
                                {t("Don'ts")}
                              </button>
                            </div>
                            <div
                              id="collapse2"
                              className="collapse show"
                              data-parent="#accordion"
                            >
                              <div className="card-body m-3">
                                <ol className="kmc-function-list" type="1">
                                  {[
                                    "Do not start the work before informing the local SWM Office.",
                                    "Do not start the work before depositing the required fee at the KMC office.",
                                    "Do not start the work without a valid payment receipt.",
                                    "Do not start the work before informing the KMC office.",
                                  ].map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ol>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <p
                        className="fontSizeClass"
                        style={{
                          border: `2px solid black`,
                          padding: "10px 50px",
                          width: "auto",
                          alignSelf: "center",
                          textAlign: "center",
                        }}
                      >
                        {t("Dispose off your daily garbage")}
                        <br />
                        {t("on time at the specified vats or in the ")}
                        <br />
                        {t("handcrafts of the sweepers.")}
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "Let not your problems hamper others.Please remember some of the simple but essential directions,mentioned above,to keep Kolkata clean. Help us to maintain a clean,green city. Remember,the city is yours. As a citizen,it is your moral duty to keep the environment clean and pollution-free."
                        )}
                      </p>
                      <p
                        className="fontSizeClass"
                        style={{
                          border: `2px solid black`,
                          padding: "10px 50px",
                          width: "auto",
                          alignSelf: "center",
                          textAlign: "center",
                        }}
                      >
                        {t("To serve you better")} <br />
                        <strong>
                          {t("Kolkata Municipal Corporation")} <br />
                        </strong>
                        {t("needs your continuous support and co-operation")}
                        <br />
                        <strong>
                          {t("Control Room : 2286-1212/1313/1414")}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Solid_wastes_home;
